import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import _environment from "./_environment/_environment";
import * as Sentry from "@sentry/react";

declare const window: any;
// define a new console
const console = (function(oldCons) {
  return {
    log: function(text: string, params1: any, params2: any) {
      if (_environment.showHandledLogs) {
        oldCons.log.apply(oldCons, arguments);
      }
    },
    info: function(text: string, params: any) {
      if (_environment.showHandledLogs) {
        oldCons.info.apply(oldCons, arguments);
      }
    },
    warn: function(text: string, params: any) {
      if (_environment.showHandledLogs) {
        oldCons.warn.apply(oldCons, arguments);
      }
    },
    error: function(text: string, params: any) {
      if (_environment.showHandledLogs) {
        oldCons.error.apply(oldCons, arguments);
      }
    },
    trace: function(text: string, params: any) {
      if (_environment.showHandledLogs) {
        oldCons.trace.apply(oldCons, arguments);
      }
    },
  };
}(window.console));

//Then redefine the old console
window.console = console;

// Sentry tracking monitor
Sentry.init({
  dsn: "https://e30f888738ae4872804c9864a6e124aa@o459238.ingest.sentry.io/5458047",
  enabled: process.env.REACT_APP_ENV === "production",
  environment: process.env.REACT_APP_ENV,
  release: _environment.version,
});


i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: "en-GB",
    fallbackLng: "en",
    debug: process.env.REACT_APP_ENV === "development",
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  }).then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>,
    document.getElementById("root"),
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
